import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import Notifications from "vue-notification";
import velocity from "velocity-animate";

// import VueCharts from 'vue-chartjs';

import NProgress from "nprogress";
import "nprogress/nprogress.css";

// for jquery and bootstrap
import jQuery from "jquery";
global.jQuery = jQuery;
global.$ = jQuery;
let Bootstrap = require("bootstrap");
// import 'bootstrap/dist/css/bootstrap.min.css';

// import home from './home.vue';
import login from "./components/account/login.vue";
import home from "./home.vue";

import dashboard from "./components/views/dashboard.vue";
import engage from "./components/views/engage.vue";

import conversation from "./components/views/conversation.vue";
import contacts from "./components/views/subpages/contacts.vue";
import autoresponse from "./components/views/subpages/autoresponse.vue";
import customforms from "./components/views/subpages/customforms.vue";
import bulksms from "./components/views/subpages/bulksms.vue";
import manageleads from "./components/views/manageleads.vue";
import contactsleads from "./components/views/parts/contactsleads";

import campaign from "./components/views/subpages/campaign.vue";
import analytics from "./components/views/analytics.vue";
import setting from "./components/views/setting.vue";
import notsupported from "./components/views/browser.vue";

import store from "./store";

// for fontawesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faCaretDown);
Vue.component("font-awesome-icon", FontAwesomeIcon);

// for element ui
import ElementUI, { DatePicker } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/en";

// for filtering datas
import DateFilter from "./filters/date";
Vue.filter("date", DateFilter);

// window.axios=axios;
Vue.use(VueRouter);
Vue.use(ElementUI, { locale });
Vue.use(Notifications, { velocity });
// Vue.use(VueCharts);

// for kendo
import "@progress/kendo-ui";
import "@progress/kendo-theme-default/dist/all.css";

import {
  Chart,
  Sparkline,
  StockChart,
  ChartInstaller
} from "@progress/kendo-charts-vue-wrapper";

import { DateinputsInstaller } from "@progress/kendo-dateinputs-vue-wrapper";

Vue.use(ChartInstaller);

Vue.use(DateinputsInstaller);

const routes = [
  {
    path: "/",
    name: "home",
    component: home
  },
  {
    path: "/login",
    name: "login",
    component: login
  },
  {
    path: "/notsupported",
    name: "notsupported",
    component: notsupported
  },
  {
    path: "/engage",
    name: engage,
    component: engage,
    meta: { requiresAuth: true }
  },
  {
    path: "/conversation",
    name: "conversation",
    component: conversation,
    meta: { requiresAuth: true }
  },
  {
    path: "/setting",
    name: "setting",
    component: setting,
    meta: { requiresAuth: true }
  },
  {
    path: "/autoresponse",
    name: "autoresponse",
    component: autoresponse,
    meta: { requiresAuth: true }
  },

  {
    path: "/contacts",
    name: "contacts",
    component: contacts,
    meta: { requiresAuth: true }
  },
  {
    path: "/campaign",
    name: "campaign",
    component: campaign,
    meta: { requiresAuth: true }
  },
  {
    path: "/bulksms",
    name: "bulksms",
    component: bulksms,
    meta: { requiresAuth: true }
  },
  {
    path: "/customforms",
    name: "customforms",
    component: customforms,
    meta: { requiresAuth: true }
  },

  {
    path: "/analytics",
    name: "analytics",
    component: analytics,
    meta: { requiresAuth: true }
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: "/manageleads",
    name: "manageleads",
    component: manageleads,
    meta: { requiresAuth: true }
  },
  {
    path: "/contactsleads",
    name: "contactsleads",
    component: contactsleads,
    meta: { requiresAuth: true }
  }
];

const router = new VueRouter({
  routes,
  mode: ""
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const authUser = JSON.parse(window.sessionStorage.getItem("authUser"));
    if (authUser && authUser.access_token) {
      next();
    } else {
      next({
        name: "login"
      });
    }
  }
  next();
});

router.beforeResolve((to, from, next) => {
  if (to.path) {
    NProgress.inc();
  }
  next();
});

router.afterEach(() => {
  NProgress.done();
});

new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App),
  components: {
    Chart,
    Sparkline,
    StockChart,
    DatePicker
  }
});



// WEBPACK FOOTER //
// ./src/main.js